import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 15 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.25 6.172v5.203c0 .313-.11.578-.328.797a1.085 1.085 0 01-.797.328h-8.25c-.313 0-.578-.11-.797-.328a1.085 1.085 0 01-.328-.797v-8.25c0-.313.11-.578.328-.797.219-.219.484-.328.797-.328h7.969c.125 0 .21.063.258.188.046.109.023.203-.07.28l-.563.563a.223.223 0 01-.188.094H2.016c-.094 0-.141.047-.141.14v7.97c0 .093.047.14.14.14h7.97c.093 0 .14-.047.14-.14v-4.5c0-.079.031-.15.094-.212l.562-.562c.078-.078.172-.094.281-.047.126.047.188.133.188.258zM13.969.5c.187 0 .281.094.281.281V3.97c0 .125-.063.21-.188.258-.109.046-.203.023-.28-.07l-1.15-1.126-6.374 6.375c-.125.14-.258.14-.399 0l-.515-.515c-.14-.141-.14-.274 0-.399l6.375-6.375L10.594.97c-.094-.078-.117-.172-.07-.281.046-.125.132-.188.257-.188h3.188z",
      fill: "#00A3FF"
    }, null, -1 /* HOISTED */)
  ])))
}